import { initializeApp, getApps, getApp, FirebaseApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
};

// console.log("Firebase config:", firebaseConfig);

const env = process.env.NEXT_PUBLIC_ENV;
const functionsRegion = process.env.NEXT_PUBLIC_FUNCTIONS_REGION;

let app: FirebaseApp;
if (!getApps().length) {
  app = initializeApp(firebaseConfig);
  console.log("Firebase app initialized");
  console.log("Environment:", env);
  console.log("Functions region:", functionsRegion);
} else {
  app = getApp();
}

export const functions = getFunctions(app, functionsRegion);
export const auth = getAuth(app);
export const db = getFirestore(app);

if (env === "development") {
  console.log("Connecting to Functions emulator");
  connectFunctionsEmulator(functions, "localhost", 5001);
  console.log("Connecting to Auth emulator");
  connectAuthEmulator(auth, "http://localhost:9099");
  console.log("Connecting to Firestore emulator");
  connectFirestoreEmulator(db, "localhost", 8080);
}

export default app;
